// Closed v1 content model. Each block has Hebrew editor metadata + field schema.
// Field types: text | textarea | url | media | boolean | select | repeater

export const BLOCKS = {
  hero: {
    type: "hero",
    label: "כותרת ראשית (Hero)",
    description: "הבאנר הראשי בראש העמוד עם תמונה גדולה, כותרת וקריאה לפעולה.",
    icon: "Sparkles",
    fields: [
      { key: "heading", type: "text", label: "כותרת", help: "המשפט הגדול שמופיע ראשון.", required: true, max: 80 },
      { key: "subheading", type: "textarea", label: "כותרת משנה", help: "משפט קצר שמסביר על המותג.", max: 200 },
      { key: "background_image", type: "media", label: "תמונת רקע", help: "תמונה איכותית ורוחבית. יחס מומלץ 16:9." },
      { key: "video_url", type: "url", label: "קישור וידאו (YouTube/Vimeo)", help: "אופציונלי. הדבקת קישור לסרטון להטמעה." },
      { key: "cta_label", type: "text", label: "טקסט כפתור", help: 'לדוגמה: "לחנות ב-Etsy".', max: 30 },
      { key: "cta_url", type: "url", label: "קישור הכפתור", help: "לרוב קישור לחנות Etsy שלך." },
    ],
    default: { heading: "EmotionalSignal", subheading: "", background_image: "", video_url: "", cta_label: "", cta_url: "" },
  },
  about: {
    type: "about",
    label: "אודות (About)",
    description: "סיפור קצר על האמנית עם תמונת דיוקן.",
    icon: "User",
    fields: [
      { key: "heading", type: "text", label: "כותרת", required: true, max: 60 },
      { key: "body", type: "textarea", label: "טקסט", help: "הסיפור שלך במילים שלך.", required: true, max: 1200 },
      { key: "image", type: "media", label: "תמונה", help: "תמונת דיוקן או סטודיו." },
      { key: "image_position", type: "select", label: "מיקום התמונה", options: [
        { value: "left", label: "משמאל" }, { value: "right", label: "מימין" },
      ], default: "right" },
    ],
    default: { heading: "About", body: "", image: "", image_position: "right" },
  },
  gallery: {
    type: "gallery",
    label: "גלריה (Gallery)",
    description: "רשת תמונות של יצירות האמנות.",
    icon: "Images",
    fields: [
      { key: "heading", type: "text", label: "כותרת", max: 60 },
      { key: "items", type: "repeater", label: "יצירות", min: 1, itemLabel: "יצירה", item_fields: [
        { key: "image", type: "media", label: "תמונה", required: true },
        { key: "caption", type: "text", label: "כיתוב", max: 80 },
        { key: "link", type: "url", label: "קישור (Etsy)" },
      ]},
    ],
    default: { heading: "Gallery", items: [] },
  },
  press: {
    type: "press",
    label: "עיתונות (Press)",
    description: "ציטוטים ואזכורים מהתקשורת.",
    icon: "Quote",
    fields: [
      { key: "heading", type: "text", label: "כותרת", max: 60 },
      { key: "items", type: "repeater", label: "ציטוטים", itemLabel: "ציטוט", item_fields: [
        { key: "quote", type: "textarea", label: "ציטוט", required: true, max: 300 },
        { key: "source", type: "text", label: "מקור", required: true, max: 80 },
        { key: "url", type: "url", label: "קישור לכתבה" },
      ]},
    ],
    default: { heading: "Press", items: [] },
  },
  contact: {
    type: "contact",
    label: "יצירת קשר (Contact)",
    description: "פרטי קשר וטופס פנייה אופציונלי.",
    icon: "Mail",
    fields: [
      { key: "heading", type: "text", label: "כותרת", max: 60 },
      { key: "email", type: "text", label: "אימייל להצגה", max: 120 },
      { key: "phone", type: "text", label: "טלפון", max: 40 },
      { key: "address", type: "text", label: "כתובת", max: 160 },
      { key: "show_form", type: "boolean", label: "להציג טופס פנייה", help: "מבקרים יוכלו לשלוח לך הודעה שתישמר במערכת." },
    ],
    default: { heading: "Contact", email: "", phone: "", address: "", show_form: true },
  },
  faq: {
    type: "faq",
    label: "שאלות ותשובות (FAQ)",
    description: "שאלות נפוצות עם מענה.",
    icon: "HelpCircle",
    fields: [
      { key: "heading", type: "text", label: "כותרת", max: 60 },
      { key: "items", type: "repeater", label: "שאלות", itemLabel: "שאלה", item_fields: [
        { key: "question", type: "text", label: "שאלה", required: true, max: 160 },
        { key: "answer", type: "textarea", label: "תשובה", required: true, max: 600 },
      ]},
    ],
    default: { heading: "FAQ", items: [] },
  },
  newsletter_teaser: {
    type: "newsletter_teaser",
    label: "ניוזלטר (טיזר)",
    description: "הזמנה קצרה להישאר מעודכנים. (תשתית עתידית)",
    icon: "Send",
    fields: [
      { key: "heading", type: "text", label: "כותרת", required: true, max: 60 },
      { key: "body", type: "textarea", label: "טקסט", max: 240 },
      { key: "cta_label", type: "text", label: "טקסט כפתור", max: 30 },
      { key: "cta_url", type: "url", label: "קישור הכפתור" },
    ],
    default: { heading: "Stay in touch", body: "", cta_label: "", cta_url: "" },
  },
  events_teaser: {
    type: "events_teaser",
    label: "אירועים (טיזר)",
    description: "רשימת אירועים או תערוכות קרובות. (תשתית עתידית)",
    icon: "CalendarDays",
    fields: [
      { key: "heading", type: "text", label: "כותרת", max: 60 },
      { key: "body", type: "textarea", label: "טקסט", max: 240 },
      { key: "items", type: "repeater", label: "אירועים", itemLabel: "אירוע", item_fields: [
        { key: "title", type: "text", label: "שם האירוע", required: true, max: 120 },
        { key: "date", type: "text", label: "תאריך", max: 60 },
        { key: "location", type: "text", label: "מיקום", max: 120 },
        { key: "url", type: "url", label: "קישור" },
      ]},
    ],
    default: { heading: "Events", body: "", items: [] },
  },
  blog_teaser: {
    type: "blog_teaser",
    label: "בלוג (טיזר)",
    description: "תצוגה מקדימה של פוסטים. (תשתית עתידית)",
    icon: "BookOpen",
    fields: [
      { key: "heading", type: "text", label: "כותרת", max: 60 },
      { key: "body", type: "textarea", label: "טקסט", max: 240 },
      { key: "items", type: "repeater", label: "פוסטים", itemLabel: "פוסט", item_fields: [
        { key: "title", type: "text", label: "כותרת הפוסט", required: true, max: 140 },
        { key: "excerpt", type: "textarea", label: "תקציר", max: 240 },
        { key: "url", type: "url", label: "קישור" },
      ]},
    ],
    default: { heading: "Journal", body: "", items: [] },
  },
};

export const BLOCK_ORDER = [
  "hero", "about", "gallery", "press", "faq",
  "events_teaser", "blog_teaser", "newsletter_teaser", "contact",
];

export const TEMPLATES = [
  { id: "landing", label: "דף נחיתה מלא", description: "Hero, אודות, גלריה, יצירת קשר", blocks: ["hero", "about", "gallery", "contact"] },
  { id: "portfolio", label: "תיק עבודות", description: "Hero, גלריה, עיתונות", blocks: ["hero", "gallery", "press"] },
  { id: "simple", label: "עמוד פשוט", description: "Hero, אודות, יצירת קשר", blocks: ["hero", "about", "contact"] },
  { id: "blank", label: "עמוד ריק", description: "בלי בלוקים — תוסיפי בעצמך", blocks: [] },
];

export const newBlock = (type) => {
  const def = BLOCKS[type];
  return {
    id: Math.random().toString(36).slice(2, 12),
    type,
    data: JSON.parse(JSON.stringify(def.default || {})),
  };
};

export const validateBlock = (block) => {
  const def = BLOCKS[block.type];
  const errors = [];
  if (!def) return errors;
  for (const f of def.fields) {
    const val = block.data?.[f.key];
    if (f.required && (!val || (typeof val === "string" && !val.trim()))) {
      errors.push(`חסר שדה חובה: ${f.label}`);
    }
    if (f.type === "repeater") {
      const items = val || [];
      if (f.min && items.length < f.min) {
        errors.push(`${f.label}: יש להוסיף לפחות ${f.min} פריט.`);
      }
      items.forEach((it, i) => {
        for (const sf of f.item_fields) {
          if (sf.required && (!it?.[sf.key] || (typeof it[sf.key] === "string" && !it[sf.key].trim()))) {
            errors.push(`${f.label} #${i + 1}: חסר ${sf.label}.`);
          }
        }
      });
    }
  }
  return errors;
};


/* ================= EmotionalSignal surreal-styled block library ================= */
const NAV = { key: "nav_title", type: "text", label: "כותרת לתפריט העליון (אופציונלי)", help: "אם תמלאי — הבלוק יופיע בתפריט הניווט בראש הדף, ולחיצה תגלול אליו.", max: 24 };

export const ES_BLOCKS = {
  es_hero: {
    type: "es_hero", label: "כותרת ראשית — Hero", family: "es",
    description: "הבאנר הפותח עם עין ענקית, כותרת ענקית וכפתורי קריאה לפעולה.",
    fields: [
      NAV,
      { key: "eyebrow", type: "text", label: "טקסט קטן עליון", max: 60 },
      { key: "heading", type: "text", label: "כותרת ענקית", required: true, max: 90 },
      { key: "subheading", type: "textarea", label: "כותרת משנה", max: 240 },
      { key: "image", type: "artwork", label: "יצירת רקע / עין ראשית" },
      { key: "video_url", type: "url", label: "קישור וידאו (YouTube/Vimeo)" },
      { key: "cta_label", type: "text", label: "כפתור ראשי — טקסט", max: 30 },
      { key: "cta_url", type: "url", label: "כפתור ראשי — קישור (Etsy)" },
      { key: "cta2_label", type: "text", label: "כפתור משני — טקסט", max: 30 },
      { key: "cta2_url", type: "text", label: "כפתור משני — קישור/עוגן (למשל #sec-...)", max: 120 },
    ],
    default: { nav_title: "", eyebrow: "Surreal Art · Handmade Signals", heading: "Surreal Art for Unspoken Feelings", subheading: "A home for beautifully complicated minds and dreamers.", image: "/assets/es/eye-hero.webp", video_url: "", cta_label: "Step Into the Signal", cta_url: "", cta2_label: "Claim Your Symbol", cta2_url: "#sec-symbols" },
  },
  es_manifesto: {
    type: "es_manifesto", label: "מניפסט / סיפור", family: "es",
    description: "מקטע סיפור עם תמונה בצד, פסקאות וציטוט מודגש.",
    fields: [
      NAV,
      { key: "eyebrow", type: "text", label: "טקסט קטן עליון", max: 60 },
      { key: "heading", type: "text", label: "כותרת", required: true, max: 80 },
      { key: "image", type: "artwork", label: "תמונה" },
      { key: "body", type: "textarea", label: "טקסט (אפשר כמה פסקאות)", max: 1600 },
      { key: "quote", type: "textarea", label: "ציטוט מודגש", max: 320 },
      { key: "quote_author", type: "text", label: "שם המצטט/ת", max: 60 },
    ],
    default: { nav_title: "Manifesto", eyebrow: "The Story Behind the Signals", heading: "The Beauty of Imperfect Intention", image: "/assets/es/faces.webp", body: "", quote: "", quote_author: "Rimona Gal" },
  },
  es_symbols: {
    type: "es_symbols", label: "מילון סמלים (כרטיסים)", family: "es",
    description: "כרטיסים מתהפכים עם סמל, שם ומשמעות.",
    fields: [
      NAV,
      { key: "eyebrow", type: "text", label: "טקסט קטן עליון", max: 60 },
      { key: "heading", type: "text", label: "כותרת", max: 80 },
      { key: "subheading", type: "textarea", label: "כותרת משנה", max: 200 },
      { key: "items", type: "repeater", label: "סמלים", itemLabel: "סמל", min: 1, item_fields: [
        { key: "image", type: "artwork", label: "יצירה", required: true },
        { key: "name", type: "text", label: "שם הסמל", required: true, max: 40 },
        { key: "meaning", type: "textarea", label: "משמעות", required: true, max: 240 },
      ]},
    ],
    default: { nav_title: "Symbols", eyebrow: "A Lexicon for Outsiders", heading: "The Symbolic Dictionary", subheading: "Feelings encoded into a visual language. Tap a symbol to read its meaning.", items: [] },
  },
  es_gallery: {
    type: "es_gallery", label: "גלריית יצירות", family: "es",
    description: "רשת תמונות סוריאליסטית עם כיתובים.",
    fields: [
      NAV,
      { key: "eyebrow", type: "text", label: "טקסט קטן עליון", max: 60 },
      { key: "heading", type: "text", label: "כותרת", max: 80 },
      { key: "items", type: "repeater", label: "יצירות", itemLabel: "יצירה", min: 1, item_fields: [
        { key: "image", type: "artwork", label: "יצירה", required: true },
        { key: "caption", type: "text", label: "כיתוב", max: 60 },
        { key: "link", type: "url", label: "קישור (Etsy)" },
      ]},
    ],
    default: { nav_title: "Gallery", eyebrow: "", heading: "The Gallery", items: [] },
  },
  es_collections: {
    type: "es_collections", label: "קולקציות מוצרים", family: "es",
    description: "רשת מוצרים עם תמונה, כותרת, תיאור וקישור Etsy.",
    fields: [
      NAV,
      { key: "eyebrow", type: "text", label: "טקסט קטן עליון", max: 60 },
      { key: "heading", type: "text", label: "כותרת", max: 80 },
      { key: "body", type: "textarea", label: "טקסט", max: 320 },
      { key: "items", type: "repeater", label: "מוצרים", itemLabel: "מוצר", min: 1, item_fields: [
        { key: "image", type: "artwork", label: "יצירה", required: true },
        { key: "kicker", type: "text", label: "תגית קטנה", max: 40 },
        { key: "title", type: "text", label: "כותרת", required: true, max: 60 },
        { key: "desc", type: "textarea", label: "תיאור", max: 240 },
        { key: "url", type: "url", label: "קישור המוצר ב-Etsy", help: "הדביקי כאן את הקישור לעמוד המוצר ב-Etsy. אם תשאירי ריק — הכפתור יוביל לחנות הראשית." },
      ]},
      { key: "cta_label", type: "text", label: "כפתור סיום — טקסט", max: 40 },
      { key: "cta_url", type: "url", label: "כפתור סיום — קישור" },
    ],
    default: { nav_title: "Artifacts", eyebrow: "Artifacts of the Inner World", heading: "Live With the Signal", body: "", items: [], cta_label: "Take ownership of the signal", cta_url: "" },
  },
  es_socials: {
    type: "es_socials", label: "רשתות חברתיות", family: "es",
    description: "מקטע קישורים לרשתות החברתיות עם סמלים גדולים וברורים.",
    fields: [
      NAV,
      { key: "eyebrow", type: "text", label: "טקסט קטן עליון", max: 60 },
      { key: "heading", type: "text", label: "כותרת", max: 80 },
      { key: "subheading", type: "textarea", label: "כותרת משנה", max: 200 },
      { key: "items", type: "repeater", label: "רשתות", itemLabel: "רשת", min: 1, item_fields: [
        { key: "platform", type: "select", label: "רשת", options: [
          { value: "instagram", label: "Instagram" }, { value: "tiktok", label: "TikTok" },
          { value: "youtube", label: "YouTube" }, { value: "facebook", label: "Facebook" },
          { value: "etsy", label: "Etsy" }, { value: "x", label: "X / Twitter" },
          { value: "pinterest", label: "Pinterest" }, { value: "email", label: "Email" },
        ], default: "instagram" },
        { key: "url", type: "url", label: "קישור", required: true },
        { key: "label", type: "text", label: "כיתוב מתחת לסמל (אופציונלי)", max: 30 },
      ]},
    ],
    default: { nav_title: "Follow", eyebrow: "Find Us in the Wild", heading: "Follow the Signal", subheading: "Join the community across the platforms.", items: [] },
  },
  es_richtext: {
    type: "es_richtext", label: "מקטע טקסט מעוצב", family: "es",
    description: "מקטע פשוט עם כותרת וטקסט, ממורכז.",
    fields: [
      NAV,
      { key: "eyebrow", type: "text", label: "טקסט קטן עליון", max: 60 },
      { key: "heading", type: "text", label: "כותרת", required: true, max: 90 },
      { key: "body", type: "textarea", label: "טקסט", max: 900 },
    ],
    default: { nav_title: "", eyebrow: "", heading: "A New Section", body: "" },
  },
  es_newsletter: {
    type: "es_newsletter", label: "הרשמה לניוזלטר", family: "es",
    description: "מקטע איסוף מיילים של מעריצים לקראת קולקציות חדשות.",
    fields: [
      NAV,
      { key: "eyebrow", type: "text", label: "טקסט קטן עליון", max: 60 },
      { key: "heading", type: "text", label: "כותרת", required: true, max: 90 },
      { key: "body", type: "textarea", label: "טקסט", max: 320 },
    ],
    default: { nav_title: "", eyebrow: "Stay in the Signal", heading: "Be First to Feel the Next Collection", body: "No noise, no spam — just a quiet signal when new hand-drawn artifacts drop." },
  },
  es_cta: {
    type: "es_cta", label: "קריאה לפעולה (סיום)", family: "es",
    description: "מקטע סיום גדול עם כותרת, טקסט וכפתור.",
    fields: [
      NAV,
      { key: "heading", type: "text", label: "כותרת", required: true, max: 90 },
      { key: "body", type: "textarea", label: "טקסט", max: 400 },
      { key: "cta_label", type: "text", label: "כפתור — טקסט", max: 40 },
      { key: "cta_url", type: "url", label: "כפתור — קישור (Etsy)" },
    ],
    default: { nav_title: "", heading: "Joining the World of EmotionalSignal", body: "To the outsiders and the dreamers: thank you for being here. This is a connection, not a transaction.", cta_label: "Find Your Signal on Etsy", cta_url: "" },
  },
};

export const ES_BLOCK_ORDER = [
  "es_hero", "es_manifesto", "es_symbols", "es_gallery",
  "es_collections", "es_socials", "es_richtext", "es_newsletter", "es_cta",
];

Object.assign(BLOCKS, ES_BLOCKS);
